import React from "react";
import "../../../css/buttons/SecondaryButton.css";

const scrollToServices = () => {
  document
    .getElementById("services")
    ?.scrollIntoView({ behavior: "smooth", block: "start" });
};

const SecondaryButtonSmall = ({ onClick, text }) => {
  const handleClick =
    onClick ||
    (() => {
      const label = text?.toLowerCase() || "";

      if (label.includes("service")) {
        scrollToServices();
      }
    });

  return (
    <button type="button" className="secondary-button" onClick={handleClick}>
      <div className="button-text-small text-primary-1">{text}</div>
    </button>
  );
};

export default SecondaryButtonSmall;
